import React, { createContext, useContext } from 'react';
import type { FooterStaticStrings } from '../utils/footer/buildFooterStaticStrings';

const FooterStringsContext = createContext<FooterStaticStrings | null>(null);

export function FooterStringsProvider({
  strings,
  children,
}: {
  strings: FooterStaticStrings;
  children: React.ReactNode;
}) {
  return (
    <FooterStringsContext.Provider value={strings}>
      {children}
    </FooterStringsContext.Provider>
  );
}

export function useFooterStrings(): FooterStaticStrings | null {
  return useContext(FooterStringsContext);
}
